import { createSlice } from '@reduxjs/toolkit';

/**
 * @typedef FooterBanner
 * @type {Object}
 * @property {string} title
 * @property {string} subTitle
 * @property {string} description
 * @property {string} linkText
 * @property {string} linkTarget
 * @property {string} imageUrl
 */

/**
 * @typedef CommonState
 * @type {Object}
 * @property {FooterBanner} footerBanner
 */

/**
 * @function initialState
 * @returns {CommonState}
 */
const initialState = () => {
  return {
    footerBanner: {}
  };
};

export const commonReducer = createSlice({
  name: 'common',
  initialState: { ...initialState() },
  reducers: {
    setFooterBanner: (state, action) => ({ ...state, footerBanner: { ...state.footerBanner, ...action.payload } }),
    resetFooterBanner: (state) => ({ ...state, footerBanner: initialState().footerBanner }),
    resetStore: (state) => Object.assign(state, initialState())
  }
});

// Action creators are generated for each case reducer function
export const { setFooterBanner, resetFooterBanner, resetStore } = commonReducer.actions;

export default commonReducer.reducer;
